import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const FullPageLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f5f7fa'
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default FullPageLoader;